import React from 'react'

export default ({ isShow, filter, onFilterChange, onClearFilter }) => {
  if (!isShow) return null

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 mb-4">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 md:col-span-3">
          <input
            type="text"
            value={filter.mainPaxName || ''}
            onChange={(e) =>
              onFilterChange('mainPaxName', e.currentTarget.value)
            }
            placeholder="Passenger Name"
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all"
          />
        </div>
        <div className="col-span-12 md:col-span-3">
          <input
            type="text"
            value={filter.productName || ''}
            onChange={(e) =>
              onFilterChange('productName', e.currentTarget.value)
            }
            placeholder="Product"
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all"
          />
        </div>
        <div className="col-span-12 md:col-span-4">
          <select
            value={filter.status || ''}
            onChange={(e) => onFilterChange('status', e.target.value || null)}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all bg-white"
          >
            <option value="">Status</option>
            <option value="tentative">TENTATIVE</option>
            <option value="confirmed">CONFIRMED</option>
            <option value="completed">COMPLETED</option>
            <option value="noShow">NOSHOW</option>
            <option value="canceled">CANCELED</option>
          </select>
        </div>
        <div className="col-span-12 md:col-span-2">
          <button
            onClick={onClearFilter}
            className="w-full md:w-auto px-4 py-2.5 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 transition-all flex items-center justify-center gap-2"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
            Clear Filter
          </button>
        </div>
      </div>
    </div>
  )
}
